/**
 * @file: useTermsOfServiceHtmlSource.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { kDefaultTermsOfServiceUrl } from '@euler/functions/constants';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { PixelScaleFn } from '@euler/functions/responsive/utils';
import { useMemo } from 'react';
import { convertHtmlToText } from '../convertHtmlToText';
import { useStoreConfiguration } from '../useStoreConfiguration';

export const useTermsOfServiceHtmlSource = () => {
  const { rpx } = useResponsiveContext();
  const storeConfiguration = useStoreConfiguration();
  return useMemo(
    () =>
      storeConfiguration.serviceAgreement &&
      convertHtmlToText(storeConfiguration.serviceAgreement.content)
        ? {
            html: termsOfServiceHtml(
              storeConfiguration.serviceAgreement.content,
              rpx,
            ),
          }
        : {
            uri: kDefaultTermsOfServiceUrl,
          },
    [rpx, storeConfiguration.serviceAgreement],
  );
};

function termsOfServiceHtml(content: string, rpx: PixelScaleFn) {
  return [
    '<!DOCTYPE html>',
    '<html>',
    '<head>',
    '<meta charset="utf-8" />',
    '<title>售后维修协议</title>',
    '<meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, user-scalable=no" />',
    '<style type="text/css">',
    `html {font-size: ${rpx(16)}px; padding: 0; margin: 0; }`,
    'body {padding: 0; margin: 0; padding-bottom: 5rem; }',
    'h1 {text-align: center; margin-top: 1rem; margin-bottom: 1rem;}',
    'p { padding: 0; text-indent: 2rem; line-height: 2rem; margin-bottom: 1rem !important; font-size: 1rem !important; font-family: inherit !important; margin-top: 0 !important;}',
    'ol, ul { margin-left: 0; padding-left: 1em; padding-inline-start: 1rem; }',
    'div { padding: 0; margin: 0; }',
    '</style>',
    '</head>',
    '<body>',
    '<h1>售后服务协议</h1>',
    content,
    '</body>',
    '</html>',
  ].join('');
}
